import React from 'react';
import PropTypes from 'prop-types';

import * as types from '../../../constants/questionType';
import FieldSetMostLeast from '../../../components/FieldSetMostLeast/FieldSetMostLeast';
import FieldSetTrueFalse from '../../../components/FieldSetTrueFalse/FieldSetTrueFalse';
import FieldSetAgreeScale from '../../../components/FieldSetAgreeScale/FieldSetAgreeScale';
import FieldSetSingleResponse from '../../../components/FieldSetSingleResponse/FieldSetSingleResponse';
import FieldSetDropDown from '../../../components/FieldSetDropDown/FieldSetDropDown';

const QuestionTypeSwitch = (props) => {
    switch (props.type) {
        case types.MOST_LEAST:
            return (
                <FieldSetMostLeast
                    label={props.text}
                    {...props}
                />
            );
        case types.TRUE_FALSE:
        case types.TABULAR_TRUE_FALSE:
            return (
                <FieldSetTrueFalse
                    label={props.text}
                    {...props}
                />
            );
        case types.AGREE_SCALE:
        case types.TABULAR_CHECKBOX:
            return (
                <FieldSetAgreeScale
                    label={props.text}
                    {...props}
                />
            );
        case types.SINGLE_RESPONSE:
            return (
                <FieldSetSingleResponse
                    label={props.text}
                    {...props}
                />
            );
        case types.DROPDOWN:
            return (
                <FieldSetDropDown
                    label={props.text}
                    {...props}
                />
            );
        default:
            return null;
    }
};

QuestionTypeSwitch.propTypes = {
    type: PropTypes.oneOf(
        Object.values(types),
        '',
    ),
};

QuestionTypeSwitch.defaultProps = {
    type: '',
};

export default QuestionTypeSwitch;
